"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var Section_1 = __importDefault(require("./Section"));
var QuoteTotal_1 = __importDefault(require("./QuoteTotal"));
var classnames_1 = __importDefault(require("classnames"));
var QuoteComponents_1 = require("./QuoteComponents");
var inversify_react_1 = require("inversify-react");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var ReactQuote = (function (_super) {
    __extends(ReactQuote, _super);
    function ReactQuote() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleQuoteAccepted = function () {
            _this.quoteViewStore.disableInteraction();
        };
        return _this;
    }
    ReactQuote.prototype.componentDidMount = function () {
        var _a;
        (_a = this.appEvents) === null || _a === void 0 ? void 0 : _a.on("accepted", this.handleQuoteAccepted);
    };
    ReactQuote.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.appEvents) === null || _a === void 0 ? void 0 : _a.removeListener("accepted", this.handleQuoteAccepted);
    };
    ReactQuote.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className) },
            this.quote.sections.map(function (section) { return (react_1.default.createElement(react_1.default.Fragment, { key: section.id },
                react_1.default.createElement(Section_1.default, { key: section.id, section: section, selectSection: function () {
                        _this.quote.setSectionSelection(section, !section.selected);
                    } }),
                _this.quoteComponents.SectionAddButton && react_1.default.createElement(_this.quoteComponents.SectionAddButton, { section: section }))); }),
            this.quote.showQuoteTotals && react_1.default.createElement(QuoteTotal_1.default, null)));
    };
    var _a, _b, _c, _d;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _a : Object)
    ], ReactQuote.prototype, "quote", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_b = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _b : Object)
    ], ReactQuote.prototype, "quoteComponents", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_c = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _c : Object)
    ], ReactQuote.prototype, "quoteViewStore", void 0);
    __decorate([
        inversify_react_1.resolve.optional("appEvents"),
        __metadata("design:type", typeof (_d = typeof NodeJS !== "undefined" && NodeJS.EventEmitter) === "function" ? _d : Object)
    ], ReactQuote.prototype, "appEvents", void 0);
    ReactQuote = __decorate([
        mobx_react_1.observer
    ], ReactQuote);
    return ReactQuote;
}(react_1.default.Component));
exports.default = ReactQuote;
